import { h } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';

// Components
import Icon from '../Global/Icon';
import Trans from '../Global/Translation';
import { actionHandler, stepHasRequiredData } from '../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../constants/Steps';
import { getShowForProducts, getSectionById, isFirstStep } from '../../utilities/section/sectionUtils';
import { replaceAll } from '../../utilities/common';
import BackButton from '../Global/BackButton';

const FormActions = ({
  actionProps,
  dispatch,
  formActions,
  formParams,
  isValid,
  submitText,
  tracking,
  values,
  waitText,
  actionVariant,
  error,
  setFieldValue,
  translations,
  submitIcon,
  applyFormSubmitClass,
  btn,
  userData,
  currentPageData,
  currentSectionId,
  packageData,
  sectionOrder,
  finishedSections,
}) => {
  // Create new array including every buttons and variants which shouldn't be next to submit button
  const submitVariants = ['submit'];
  const actionsProps = actionProps ? getShowForProducts(actionProps, values).filter(
    actionProp => !(actionProp.variant && submitVariants.includes(actionProp.variant))
  ) : [];
  // Create new array including every buttons that should be next to submit button
  const actionsButtons = actionProps ? getShowForProducts(actionProps, values).filter(
    actionProp => actionProp.variant && submitVariants.includes(actionProp.variant)
  ) : [];

  const submitLabel = replaceAll(submitText, translations, values);

  const submitClass = classNames(
    tracking,
    {
      'form-submit': applyFormSubmitClass,
      'form-submit--primary': applyFormSubmitClass,
    },
    'button',
    'button--primary', {
      'button--loading': waitText,
    }
  );
  const actionsPropsClass = classNames(
    'actions__props', {
      [`actions__props--${actionVariant}`]: actionVariant,
    }
  );

  if (error) {
    return <div/>;
  }

  const activeSectionData = getSectionById(currentSectionId, packageData);
  const currentProgress = {
    backButtonConfig: activeSectionData.backButtonConfig,
  };
  return (
    <div className="form__actions">

      {actionsProps.length > 0 &&
      <ul className={actionsPropsClass}>
        {actionsProps.map(actionProp => {
          const inputParams = {
            ...formParams,
            ...actionProp,
            values,
          };
          const InputComponent = stepComponents[actionProp.type];
          return (<InputComponent {...inputParams}/>);
        })
        }
      </ul>
      }

      <div className="NavigationContainer">
        {currentSectionId !== 1 &&
          <BackButton
            dispatch={dispatch}
            config={currentProgress.backButtonConfig}
          />
        }
        {actionsButtons.length > 0 &&
        actionsButtons.map(actionProp => {
          const inputParams = {
            ...formParams,
            ...actionProp,
            values,
          };
          const InputComponent = stepComponents[actionProp.type];
          return (<InputComponent {...inputParams}/>);
        })
        }

        <button
          className={submitClass}
          onClick={e => actionHandler(formActions, null, e, dispatch, { ...values, setFieldValue })}
          ref={node => (btn = node)} // eslint-disable-line no-param-reassign
          type="submit"
          disabled={!isValid}
          data-tealium={`{"link_text": "${submitLabel}"}`}
        >
          <span>
            {submitLabel}
            {submitIcon &&
              <Icon icon="chevronLeft" fill="white"/>
            }
          </span>
        </button>
      </div>

      {/* Loading Icon */}
      {waitText &&
      <div className="actions__loading">
        <Trans value={waitText}/>
      </div>
      }

    </div>
  );
};

export default compose(
  connect(state => {
    const {
      app: {
        error,
      },
      section: { packageData: { translations } },
    } = state;
    return {
      error,
      translations,
    };
  })
)(FormActions);

FormActions.defaultProps = {
  waitText: null,
  formActions: null,
  formParams: null,
  actionProps: [],
  tracking: ['tealiumSubmit'],
  actionVariant: '',
  setFieldValue: null,
  submitIcon: true,
  applyFormSubmitClass: true,
};

FormActions.propTypes = {
  isValid: PropTypes.bool.isRequired,
  submitText: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  tracking: PropTypes.array,
  actionVariant: PropTypes.string,
  formParams: PropTypes.object,
  actionProps: PropTypes.array,
  formActions: PropTypes.array,
  waitText: PropTypes.string,
  error: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func,
  translations: PropTypes.object.isRequired,
  submitIcon: PropTypes.bool,
  applyFormSubmitClass: PropTypes.bool,
  btn: PropTypes.object.isRequired,
  currentSectionId: PropTypes.number.isRequired,
  currentPageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  packageData: PropTypes.object.isRequired,
  finishedSections: PropTypes.array.isRequired,
  sectionOrder: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Form/FormActions.jsx